import { requisitarJson } from '../../../shared/api/http';

export type EstadoEtapa =
    | 'nao_aberta'
    | 'aguardando'
    | 'jogando'
    | 'enviado'
    | 'apurado'
    | 'encerrada_sem_entrega';

export interface EtapaDoGrupo {
    estado: EstadoEtapa;
    pontuacao: number | null;
    recebido_em: string | null;
}

export interface FaseDaTurma {
    fase: string;
    rotulo: string;
    status: 'aberta' | 'encerrada' | 'nao_aberta';
    aberta_em: string | null;
    encerrada_em: string | null;
    entregues: number;
    total: number;
}

export interface ComandoDoGrupo {
    fase: string;
    rotulo: string;
    pode_abrir: boolean;
    pode_encerrar: boolean;
    /** Por que não dá, quando não dá: o grupo está em outra fase. */
    motivo: string | null;
}

export interface GrupoNoQuadro {
    grupo_id: string;
    /** A fase que este grupo tem aberta agora; null = fora de fase. */
    fase_aberta: string | null;
    comandos: ComandoDoGrupo[];
    participantes: number;
    online: number;
    /** Fases abertas em que o grupo pode estar agora; vazio = fora de sala. */
    salas: string[];
    /** Preenchido quando há mais de uma: o grupo joga uma fase por vez. */
    conflito: { fase_que_abriu_depois: string; fase_anterior: string } | null;
    etapas: Record<string, EtapaDoGrupo>;
}

export interface FaseComandavel {
    fase: string;
    rotulo: string;
    status: 'aberta' | 'encerrada' | 'nao_aberta';
    pode_abrir: boolean;
    pode_encerrar: boolean;
    /** Grupos em outra fase, que recusam o atalho da turma inteiro. */
    impedidos?: string[];
}

export interface FaseComandada {
    turma_id: string;
    fase: string;
    status: string;
    tablets: number;
    bibliotecas_liberadas: number;
    grupos_consolidados: number;
}

export interface AndamentoDaTurma {
    turma_id: string;
    /** Todas as fases comandáveis, inclusive as que a turma ainda não abriu. */
    fases_comandaveis: FaseComandavel[];
    fases: FaseDaTurma[];
    grupos: GrupoNoQuadro[];
    resumo: {
        grupos: number;
        participantes: number;
        online: number;
        jogando: number;
        em_conflito: number;
    };
}

export function obterAndamento(turmaId: string): Promise<AndamentoDaTurma> {
    return requisitarJson(`/api/v1/andamento?turma_id=${encodeURIComponent(turmaId)}`);
}

export function comandarFase(
    fase: string,
    turmaId: string,
    acao: 'abrir' | 'encerrar',
    csrfToken: string,
    grupoId?: string,
): Promise<FaseComandada> {
    return requisitarJson(`/api/v1/fases/${encodeURIComponent(fase)}/${acao}`, {
        method: 'POST',
        csrfToken,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(grupoId ? { turma_id: turmaId, grupo_id: grupoId } : { turma_id: turmaId }),
    });
}
